(function (window, document) {
  console.log("MVT Engine: Utils module loaded");

  const VISITOR_ID_KEY_PREFIX = "mvtVisitorId";
  const loadedScripts = [];

  const UTILS = {
    getCookie: function (name) {
      const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      if (match) return match[2];
      return null;
    },

    _rootDomain: undefined,
    getRootDomain: function () {
      if (this._rootDomain !== undefined) return this._rootDomain;
      var host = (window.location.hostname || "").toLowerCase();

      if (!host || host.indexOf(".") === -1 || /^[0-9.]+$/.test(host)) {
        this._rootDomain = "";
        return this._rootDomain;
      }
      var parts = host.split(".");
      for (var i = parts.length - 1; i >= 0; i--) {
        var candidate = parts.slice(i).join(".");
        var probe = "__mvt_rd_probe";
        document.cookie = probe + "=1; domain=." + candidate + "; path=/; SameSite=Lax";
        if (document.cookie.indexOf(probe + "=1") !== -1) {
          document.cookie =
            probe +
            "=; domain=." +
            candidate +
            "; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax";
          this._rootDomain = candidate;
          return this._rootDomain;
        }
      }
      this._rootDomain = "";
      return this._rootDomain;
    },

    setCookie: function (name, value, days) {
      if (window.__MVT_CONSENT_REQUIRED__ && !window.__MVT_CONSENT_GRANTED__) {
        return;
      }
      let expires = "";
      if (days) {
        const date = new Date();

        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }

      var root = this.getRootDomain();
      var domainAttr = root ? "; domain=." + root : "";

      document.cookie =
        name + "=" + (value || "") + expires + domainAttr + "; path=/; SameSite=Lax;";
    },

    getProjectKey: function (paramName) {
      const scripts = document.querySelectorAll(
        'script[src*="engine.js"],script[data-mvt="engine"]',
      );
      if (scripts.length > 0) {
        const script = scripts[scripts.length - 1];
        const inlineKey = script.getAttribute("data-project-key");
        if (inlineKey) return inlineKey;
        try {
          const url = new URL(script.src);

          const fromQuery = url.searchParams.get("key") || url.searchParams.get(paramName);
          if (fromQuery) return fromQuery;
        } catch (e) {}
      }

      if (window) {
        if (window.MVTConfig && window.MVTConfig.projectKey) return window.MVTConfig.projectKey;
        if (window.MVT && window.MVT.projectKey) return window.MVT.projectKey;
        if (window.ABTestConfig && window.ABTestConfig.projectKey)
          return window.ABTestConfig.projectKey;
      }

      return null;
    },

    removeFlickerClass: function (className) {
      if (window.rmfk && typeof window.rmfk === "function") {
        window.rmfk();
        return;
      }

      const htmlEl = document.documentElement;
      if (htmlEl && htmlEl.className.includes(className)) {
        htmlEl.className = htmlEl.className.replace(className, "").trim();
      }
    },

    sanitizeSelector: function (selector) {
      try {
        return String(selector || "")
          .replace(/\.+(\s|$|:|>)/g, "$1")
          .replace(/\.\./g, ".")
          .replace(/(?:^|\s)\.(?=\s|$)/g, "")
          .trim();
      } catch (e) {
        return "";
      }
    },

    trackingParams: [
      "fbclid",
      "fbc_id",
      "fb_ad_id",
      "h_ad_id",
      "ad_id",
      "adset_id",
      "adgroupid",
      "campaign_id",
      "placement",
      "gclid",
      "gclsrc",
      "gad_source",
      "gbraid",
      "wbraid",
      "dclid",
      "msclkid",
      "ttclid",
      "twclid",
      "li_fat_id",
      "igshid",
      "epik",
      "ScCid",
      "mc_cid",
      "mc_eid",
      "_ga",
      "_gl",
      "yclid",
      "rdt_cid",
      "vmcid",
    ],

    isTrackingParam: function (name) {
      const key = String(name || "").toLowerCase();
      if (key.indexOf("utm_") === 0) return true;
      if (key.indexOf("hsa_") === 0) return true;
      for (let i = 0; i < UTILS.trackingParams.length; i++) {
        if (key === UTILS.trackingParams[i].toLowerCase()) return true;
      }
      return false;
    },

    normalizeUrlForConfig: function (href) {
      try {
        const url = new URL(href);
        const kept = [];
        url.searchParams.forEach((value, name) => {
          if (!UTILS.isTrackingParam(name)) kept.push([name, value]);
        });

        kept.sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0));
        const params = new URLSearchParams();
        for (let i = 0; i < kept.length; i++) params.append(kept[i][0], kept[i][1]);
        const query = params.toString();
        url.search = query ? "?" + query : "";
        url.hash = "";
        return url.toString();
      } catch (e) {
        return href;
      }
    },

    _scopedHidden: [],

    _scopedReleased: [],

    _renderScopedHide: function () {
      const head = document.head || document.documentElement;
      if (!head) return false;
      let style = document.getElementById("mvt-scoped-hide");
      if (UTILS._scopedHidden.length === 0) {
        if (style && style.parentNode) style.parentNode.removeChild(style);
        return false;
      }
      let rules = "";
      for (let i = 0; i < UTILS._scopedHidden.length; i++) {
        rules += UTILS._scopedHidden[i] + "{opacity:0!important}";
      }
      if (!style) {
        style = document.createElement("style");
        style.id = "mvt-scoped-hide";
        head.appendChild(style);
      }
      style.textContent = rules;
      return true;
    },

    injectScopedHide: function (selectors) {
      try {
        if (!Array.isArray(selectors) || selectors.length === 0) return false;
        let added = false;
        for (let i = 0; i < selectors.length; i++) {
          const sel = UTILS.sanitizeSelector(selectors[i]);
          if (!sel) continue;

          if (UTILS._scopedReleased.indexOf(sel) !== -1) continue;
          if (UTILS._scopedHidden.indexOf(sel) === -1) {
            UTILS._scopedHidden.push(sel);
            added = true;
          }
        }
        if (!added) return UTILS._scopedHidden.length > 0;
        return UTILS._renderScopedHide();
      } catch (e) {
        return false;
      }
    },

    unhideScopedSelector: function (selector) {
      try {
        const sel = UTILS.sanitizeSelector(selector);
        if (!sel || UTILS._scopedHidden.length === 0) return;

        let target = null;
        try {
          target = document.querySelector(sel);
        } catch (e) {
          target = null;
        }

        const keep = [];
        const released = [];
        for (let i = 0; i < UTILS._scopedHidden.length; i++) {
          const held = UTILS._scopedHidden[i];
          let release = held === sel;
          if (!release && target) {
            try {
              release = document.querySelector(held) === target;
            } catch (e) {
              release = false;
            }
          }
          (release ? released : keep).push(held);
        }

        if (UTILS._scopedReleased.indexOf(sel) === -1) UTILS._scopedReleased.push(sel);
        for (let i = 0; i < released.length; i++) {
          if (UTILS._scopedReleased.indexOf(released[i]) === -1) {
            UTILS._scopedReleased.push(released[i]);
          }
        }
        if (keep.length === UTILS._scopedHidden.length) return;
        UTILS._scopedHidden = keep;
        UTILS._renderScopedHide();
      } catch (e) {}
    },

    releaseUnusedScopedTargets: function (variant) {
      try {
        if (UTILS._scopedHidden.length === 0) return;

        const willTouch = [];
        const ops = variant && Array.isArray(variant.data) ? variant.data : [];
        for (let i = 0; i < ops.length; i++) {
          const op = ops[i] || {};
          const sels = [op.target, op.rm, op.oriEl, op.refEl];
          for (let j = 0; j < sels.length; j++) {
            const sel = UTILS.sanitizeSelector(sels[j]);
            if (!sel) continue;
            try {
              const el = document.querySelector(sel);
              if (el && willTouch.indexOf(el) === -1) willTouch.push(el);
            } catch (e) {}
          }
        }

        const keep = [];
        for (let i = 0; i < UTILS._scopedHidden.length; i++) {
          const held = UTILS._scopedHidden[i];
          let el = null;
          try {
            el = document.querySelector(held);
          } catch (e) {
            el = null;
          }

          if (!el) {
            keep.push(held);
            continue;
          }

          if (willTouch.indexOf(el) !== -1) {
            keep.push(held);
          } else if (UTILS._scopedReleased.indexOf(held) === -1) {
            UTILS._scopedReleased.push(held);
          }
        }
        if (keep.length === UTILS._scopedHidden.length) return;
        UTILS._scopedHidden = keep;
        UTILS._renderScopedHide();
      } catch (e) {}
    },

    removeScopedHide: function () {
      try {
        UTILS._scopedHidden = [];

        UTILS._scopedReleased = [];
        const el = document.getElementById("mvt-scoped-hide");
        if (el && el.parentNode) el.parentNode.removeChild(el);
      } catch (e) {}
    },

    safeQuerySelector: function (selector) {
      return new Promise((resolve) => {
        try {
          var cleanSelector = UTILS.sanitizeSelector(selector);
          try {
            resolve(document.querySelector(cleanSelector));
          } catch (error) {
            console.warn("[safeQuerySelector] Error querying element:", error);
            resolve(null);
          }
        } catch (error) {
          resolve(null);
        }
      });
    },

    waitForSelector: function (selector, options) {
      const requested = options && options.timeoutMs;
      const timeoutMs = Number.isFinite(requested) ? Math.max(0, requested) : 2000;

      return new Promise((resolve) => {
        let cleanSelector;
        try {
          cleanSelector = UTILS.sanitizeSelector(selector);
        } catch (error) {
          resolve(null);
          return;
        }

        try {
          const existing = document.querySelector(cleanSelector);
          if (existing) {
            resolve(existing);
            return;
          }
        } catch (error) {
          resolve(null);
          return;
        }

        let observer;
        const timer = setTimeout(() => {
          if (observer) observer.disconnect();
          resolve(null);
        }, timeoutMs);

        observer = new MutationObserver(() => {
          try {
            const el = document.querySelector(cleanSelector);
            if (el) {
              clearTimeout(timer);
              observer.disconnect();
              resolve(el);
            }
          } catch (e) {
            clearTimeout(timer);
            observer.disconnect();
            resolve(null);
          }
        });

        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      });
    },

    delay: function (milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },

    preloadImage: function (url, timeoutMs) {
      return new Promise((resolve) => {
        if (!url || typeof url !== "string") {
          resolve(false);
          return;
        }
        const budget = Number.isFinite(timeoutMs) ? Math.max(0, timeoutMs) : 4000;
        let settled = false;
        const done = function (ok) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(ok);
        };
        const timer = setTimeout(function () {
          done(false);
        }, budget);
        try {
          const img = new Image();
          img.onload = function () {
            if (typeof img.decode === "function") {
              img.decode().then(
                function () {
                  done(true);
                },
                function () {
                  done(true);
                },
              );
            } else {
              done(true);
            }
          };
          img.onerror = function () {
            done(false);
          };
          img.src = url;

          if (img.complete && img.naturalWidth > 0) {
            done(true);
          }
        } catch (e) {
          done(false);
        }
      });
    },

    consentBlocked: function () {
      return window.__MVT_CONSENT_REQUIRED__ === true && window.__MVT_CONSENT_GRANTED__ !== true;
    },

    getOrCreateVisitorId: function (projectKey) {
      const suffix = projectKey ? String(projectKey) : "default";
      const storageKey = `${VISITOR_ID_KEY_PREFIX}_${suffix}`;
      const cookieKey = `${storageKey}_cookie`;
      if (!this._memVisitorIds) this._memVisitorIds = {};

      function generateId() {
        return `visitor-${suffix}-${Math.random().toString(36).slice(2, 10)}-${Date.now()}`;
      }

      let id = this.getCookie(cookieKey);
      if (!id) {
        try {
          if (window.localStorage) id = window.localStorage.getItem(storageKey);
        } catch (error) {}
      }
      if (!id) id = this._memVisitorIds[suffix];
      if (!id) id = generateId();

      this._memVisitorIds[suffix] = id;

      if (!this.consentBlocked()) {
        this.setCookie(cookieKey, id, 365);
        try {
          if (window.localStorage) window.localStorage.setItem(storageKey, id);
        } catch (error) {}
      }
      return id;
    },

    onConsentGranted: function () {
      if (!this._memVisitorIds) return;
      for (var suffix in this._memVisitorIds) {
        if (!Object.prototype.hasOwnProperty.call(this._memVisitorIds, suffix)) continue;
        var storageKey = VISITOR_ID_KEY_PREFIX + "_" + suffix;
        this.setCookie(storageKey + "_cookie", this._memVisitorIds[suffix], 365);
        try {
          if (window.localStorage)
            window.localStorage.setItem(storageKey, this._memVisitorIds[suffix]);
        } catch (error) {}
      }
    },

    normalizeHost: function (value) {
      if (!value) return "";
      var h = String(value).toLowerCase().trim();
      if (h.indexOf("://") !== -1) {
        try {
          h = new URL(h).host;
        } catch (e) {}
      } else {
        h = h.split("/")[0].split("?")[0].split("#")[0];
      }
      if (h.indexOf("www.") === 0) h = h.slice(4);
      h = h.split(":")[0];
      if (h.charAt(h.length - 1) === ".") h = h.slice(0, -1);
      return h;
    },

    stripQueryParam: function (search, name) {
      var q = search && search.charAt(0) === "?" ? search.slice(1) : search || "";
      if (!q) return "";
      var kept = q.split("&").filter(function (kv) {
        return kv && kv.split("=")[0] !== name;
      });
      return kept.length ? "?" + kept.join("&") : "";
    },

    persistVisitorId: function (projectKey, id) {
      if (!projectKey || !id || typeof id !== "string") return false;
      var suffix = String(projectKey);
      if (!this._memVisitorIds) this._memVisitorIds = {};

      this._memVisitorIds[suffix] = id;

      if (this.consentBlocked()) return true;
      var storageKey = VISITOR_ID_KEY_PREFIX + "_" + suffix;

      this.setCookie(storageKey + "_cookie", id, 365);
      try {
        if (window.localStorage) window.localStorage.setItem(storageKey, id);
      } catch (e) {}
      return true;
    },

    extractIncomingLinkToken: function (projectKey) {
      try {
        if (!projectKey || typeof window === "undefined" || !window.location) return "";
        var search = window.location.search || "";
        if (search.indexOf("_mvt_lt=") === -1) return "";
        var token = new URLSearchParams(search).get("_mvt_lt") || "";

        try {
          var clean =
            window.location.pathname +
            this.stripQueryParam(search, "_mvt_lt") +
            (window.location.hash || "");
          window.history.replaceState(window.history.state, "", clean);
        } catch (e) {}
        if (!token || token.length > 1024) return "";

        var storageKey = VISITOR_ID_KEY_PREFIX + "_" + String(projectKey);
        try {
          if (window.localStorage && window.localStorage.getItem(storageKey)) return "";
        } catch (e) {}
        if (this.getCookie(storageKey + "_cookie")) return "";
        return token;
      } catch (e) {
        console.warn("MVT Engine: extractIncomingLinkToken failed", e);
        return "";
      }
    },

    publishLinkerTokenToUrl: function (linkerToken) {
      try {
        if (!linkerToken || typeof window === "undefined" || !window.location) return;
        if (!window.history || !window.history.replaceState) return;
        var search = window.location.search || "";

        if (new URLSearchParams(search).get("_mvt_lt") === linkerToken) return;
        var stripped = String(this.stripQueryParam(search, "_mvt_lt") || "").replace(/^\?/, "");
        var params = new URLSearchParams(stripped);
        params.set("_mvt_lt", linkerToken);
        var qs = params.toString();
        var next = window.location.pathname + (qs ? "?" + qs : "") + (window.location.hash || "");
        window.history.replaceState(window.history.state, "", next);
      } catch (e) {}
    },

    decorateSiblingLinks: function (linkerToken, allowedOrigins, linkSameHost) {
      try {
        if (!linkerToken) return;
        if (typeof document === "undefined" || typeof window === "undefined") return;
        var self = this;
        var currentHost = self.normalizeHost(window.location.host);
        var siblings = {};
        var hasSibling = false;
        var origins = allowedOrigins || [];
        for (var i = 0; i < origins.length; i++) {
          var h = self.normalizeHost(origins[i]);
          if (h && h !== currentHost) {
            siblings[h] = true;
            hasSibling = true;
          }
        }
        if (linkSameHost && currentHost) {
          siblings[currentHost] = true;
          hasSibling = true;
        }
        if (!hasSibling) return;

        window.__MVT_LINKER = { token: linkerToken, siblings: siblings };
        if (window.__MVT_LINKER_ARMED) return;
        window.__MVT_LINKER_ARMED = true;
        document.addEventListener(
          "click",
          function (ev) {
            try {
              var ref = window.__MVT_LINKER;
              if (!ref || !ref.token) return;
              var a = ev.target && ev.target.closest ? ev.target.closest("a[href]") : null;
              if (!a || a.hasAttribute("download")) return;
              var url;
              try {
                url = new URL(a.href, window.location.href);
              } catch (e) {
                return;
              }
              if (url.protocol !== "http:" && url.protocol !== "https:") return;

              var rawHref = a.getAttribute("href");
              if (rawHref !== null && rawHref.charAt(0) === "#") return;
              if (
                url.pathname === window.location.pathname &&
                url.search === window.location.search
              )
                return;
              if (!ref.siblings[self.normalizeHost(url.host)]) return;
              if (url.searchParams.get("_mvt_lt")) return;
              var original = a.getAttribute("href");
              url.searchParams.set("_mvt_lt", ref.token);
              a.href = url.toString();

              window.setTimeout(function () {
                try {
                  if (original === null) a.removeAttribute("href");
                  else a.setAttribute("href", original);
                } catch (e) {}
              }, 0);
            } catch (e) {}
          },
          true,
        );

        document.addEventListener(
          "submit",
          function (ev) {
            try {
              var ref = window.__MVT_LINKER;
              if (!ref || !ref.token) return;
              var form = ev.target;
              if (!form || String(form.tagName).toLowerCase() !== "form") return;
              var action = form.getAttribute("action") || window.location.href;
              var url;
              try {
                url = new URL(action, window.location.href);
              } catch (e) {
                return;
              }
              if (url.protocol !== "http:" && url.protocol !== "https:") return;
              if (!ref.siblings[self.normalizeHost(url.host)]) return;
              var method = (form.getAttribute("method") || "get").toLowerCase();
              if (method === "post") {
                if (url.searchParams.get("_mvt_lt")) return;
                var originalAction = form.getAttribute("action");
                url.searchParams.set("_mvt_lt", ref.token);
                form.setAttribute("action", url.toString());
                window.setTimeout(function () {
                  try {
                    if (originalAction === null) form.removeAttribute("action");
                    else form.setAttribute("action", originalAction);
                  } catch (e) {}
                }, 0);
              } else {
                if (form.querySelector('input[name="_mvt_lt"]')) return;
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = "_mvt_lt";
                input.value = ref.token;
                form.appendChild(input);
                window.setTimeout(function () {
                  try {
                    if (input.parentNode) input.parentNode.removeChild(input);
                  } catch (e) {}
                }, 0);
              }
            } catch (e) {}
          },
          true,
        );
      } catch (e) {
        console.warn("MVT Engine: decorateSiblingLinks failed", e);
      }
    },

    loadScript: function (scriptPath) {
      if (!loadedScripts.includes(scriptPath)) {
        let scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.src = scriptPath;
        scriptElement.async = true;
        scriptElement.crossorigin = "anonymous";

        if (document.body) {
          document.body.appendChild(scriptElement);
        } else {
          document.addEventListener("DOMContentLoaded", () => {
            document.body.appendChild(scriptElement);
          });
        }
        loadedScripts.push(scriptPath);
      }
    },

    executeWhenReady: function (func, arg1, arg2) {
      const executeFunc = () => func(arg1, arg2);
      if ("loading" === document.readyState) {
        document.addEventListener("DOMContentLoaded", executeFunc);
      } else {
        executeFunc();
      }
    },

    isInEditorMode: function () {
      let url = new URL(window.location.href);
      let mvtParams = new URLSearchParams(url.search);

      var projectId = mvtParams.get("mvt_project") || null;
      let campaignId = mvtParams.get("campaign") || null;

      return !!(projectId && campaignId);
    },

    isLivePreviewMode: function () {
      const [preview_project, preview_id] = this.getKeysFromUrl(["preview_project", "preview_id"]);

      return !!(preview_project && preview_id);
    },

    getKeysFromUrl: function (keys) {
      let url = new URL(window.location.href);
      let mvtParams = new URLSearchParams(url.search);

      const values = [];
      for (const key of keys) {
        const value = mvtParams.get(key) || null;
        values.push(value);
      }

      return values;
    },

    getTokenForPublicVariantEndpoints: async function (PUBLIC_API_BASE, projectId) {
      const tokenUrl = `${PUBLIC_API_BASE}/variants/${projectId}/token`;
      const tokenOptions = {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      };

      console.log("MVT Engine: Token request", {
        url: tokenUrl,
        options: tokenOptions,
      });

      const tokenResponse = await fetch(tokenUrl, tokenOptions);
      console.log("MVT Engine: Token response meta", {
        status: tokenResponse.status,
        ok: tokenResponse.ok,
        redirected: tokenResponse.redirected,
        type: tokenResponse.type,
        url: tokenResponse.url,
      });

      if (!tokenResponse.ok) {
        let errorBody = null;
        try {
          errorBody = await tokenResponse.text();
        } catch (e) {}
        console.error("MVT Engine: Token response body (error)", errorBody);
        throw new Error(`Token HTTP error! status: ${tokenResponse.status}`);
      }

      const tokenPayload = await tokenResponse.json();
      return tokenPayload;
    },

    getDeviceType: function () {
      if (!window || !window.navigator) {
        console.error(
          "Navigator object is missing in the browser. Unable to determine device type.",
        );
        return "unknown";
      }

      const ua = window.navigator.userAgent;

      if (!ua) {
        console.error(
          "userAgent Object is missing in the browser. Unable to determine device type.",
        );
        return "unknown";
      }

      const isGenericTablet = /Tablet|iPad|PlayBook|Silk|Kindle|(Android(?!.*Mobile))/i.test(ua);

      const isModernIpad = ua.includes("Macintosh") && (window.navigator.maxTouchPoints || 0);

      if (isGenericTablet || isModernIpad) return "tablet";

      if (/Mobile|iPhone|iPod|Android|BlackBerry/i.test(ua)) return "mobile";

      return "desktop";
    },

    appendCfUvidToUrl: function (url) {
      if (!url || typeof url !== "string") return url;
      try {
        var out = url;
        var seen = {};

        var already = out.match(/[?&]cf_uvid=([^&#]*)/g) || [];
        for (var a = 0; a < already.length; a++) {
          var av = already[a].split("=")[1] || "";
          if (av) {
            try {
              seen[decodeURIComponent(av)] = 1;
            } catch (e) {
              seen[av] = 1;
            }
          }
        }
        var append = function (val) {
          if (!val || typeof val !== "string") return;
          val = val.trim();
          if (!val || val === "null" || seen[val]) return;
          seen[val] = 1;
          out += (out.indexOf("?") === -1 ? "?" : "&") + "cf_uvid=" + encodeURIComponent(val);
        };

        append(
          (typeof URLSearchParams === "function"
            ? new URLSearchParams(window.location.search).get("cf_uvid")
            : null) ||
            (document.cookie.match(/(?:^|;\s*)cf_uvid=([^;]*)/) || [])[1] ||
            (typeof window.cfUvid === "string" ? window.cfUvid : null) ||
            (document.querySelector('input[name="cf_uvid"]') || {}).value ||
            (document.querySelector('meta[name="cf_uvid"]') || {}).content ||
            null,
        );

        var isClickFunnels = false;
        try {
          isClickFunnels =
            !!document.querySelector(
              'script[src*="clickfunnels"],link[href*="clickfunnels"],' +
                'img[src*="clickfunnels"],[data-cf-funnel-id],[data-page-id][data-workspace-id]',
            ) ||
            /clickfunnels|myclickfunnels/i.test(document.referrer || "") ||
            typeof window.CF !== "undefined" ||
            typeof window.cfAnalytics !== "undefined";
        } catch (e) {
          isClickFunnels = false;
        }

        if (isClickFunnels) {
          var UUID = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
          var MAX_UUIDS = 6;
          var count = 0;
          var scan = function (s) {
            if (!s || count >= MAX_UUIDS) return;
            UUID.lastIndex = 0;
            var m;
            while (count < MAX_UUIDS && (m = UUID.exec(s))) {
              if (!seen[m[0]]) {
                append(m[0]);
                count++;
              }
            }
          };
          try {
            scan(document.cookie);
          } catch (e) {}
          try {
            if (window.localStorage) {
              for (var i = 0; i < window.localStorage.length && count < MAX_UUIDS; i++) {
                var k = window.localStorage.key(i);
                scan(k + "=" + (window.localStorage.getItem(k) || ""));
              }
            }
          } catch (e) {}
        }

        return out;
      } catch (e) {
        return url;
      }
    },

    normalizeUrlForCacheKey: function (url) {
      if (!url) return "";
      try {
        return String(url)
          .trim()
          .toLowerCase()
          .replace(/^https?:\/\//i, "")
          .replace(/\/+$/, "");
      } catch (e) {
        return "";
      }
    },

    cacheKey: function (projectKey, url) {
      return `mvtVariantCache_${projectKey}_${this.normalizeUrlForCacheKey(url)}`;
    },

    getCachedVariant: function (projectKey, url) {
      try {
        if (!window || !window.localStorage) return null;
        const raw = window.localStorage.getItem(this.cacheKey(projectKey, url));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && parsed.variant ? parsed : null;
      } catch (e) {
        return null;
      }
    },

    setCachedVariant: function (projectKey, url, variant, meta) {
      try {
        if (!window || !window.localStorage || !variant) return;
        const payload = {
          variant: variant,
          campaignId: (meta && meta.campaignId) || variant.campaignId || null,
          variantKey: (meta && meta.variantKey) || variant.key || null,

          activationTrigger: (meta && meta.activationTrigger) || null,
          ts: Date.now(),
        };
        window.localStorage.setItem(this.cacheKey(projectKey, url), JSON.stringify(payload));
      } catch (e) {}
    },

    _exclKey: function () {
      return "mvt_excl_committed";
    },

    getCommittedExclusions: function () {
      try {
        if (!window || !window.localStorage) return {};
        var raw = window.localStorage.getItem(this._exclKey());
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (e) {
        return {};
      }
    },

    commitExclusion: function (group, campaignId) {
      try {
        if (!group || !campaignId || !window || !window.localStorage) return;
        var map = this.getCommittedExclusions();
        if (map[group] === campaignId) return;
        map[group] = campaignId;
        window.localStorage.setItem(this._exclKey(), JSON.stringify(map));
      } catch (e) {}
    },

    isExcluded: function (group, campaignId) {
      if (!group) return false;
      var lockedTo = this.getCommittedExclusions()[group];
      return !!lockedTo && lockedTo !== campaignId;
    },

    serializeCommittedExclusions: function () {
      try {
        var map = this.getCommittedExclusions();
        var parts = [];
        for (var g in map) {
          if (Object.prototype.hasOwnProperty.call(map, g) && g && map[g]) {
            parts.push(g + ":" + map[g]);
          }
        }
        return parts.join(",");
      } catch (e) {
        return "";
      }
    },

    clearCachedVariant: function (projectKey, url) {
      try {
        if (!window || !window.localStorage) return;
        window.localStorage.removeItem(this.cacheKey(projectKey, url));
      } catch (e) {}
    },

    manifestCacheKey: function (projectKey) {
      return "mvtSelectorManifest_" + projectKey;
    },

    getCachedManifest: function (projectKey) {
      try {
        if (!window || !window.localStorage) return null;
        const raw = window.localStorage.getItem(this.manifestCacheKey(projectKey));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && Array.isArray(parsed.selectors) ? parsed : null;
      } catch (e) {
        return null;
      }
    },

    setCachedManifest: function (projectKey, manifest) {
      try {
        if (!window || !window.localStorage || !manifest || !Array.isArray(manifest.selectors))
          return;
        const payload = {
          version: manifest.version || "",
          selectors: manifest.selectors,
          ts: Date.now(),
        };
        window.localStorage.setItem(this.manifestCacheKey(projectKey), JSON.stringify(payload));
      } catch (e) {}
    },

    fetchSelectorManifest: function (projectKey, changesBase) {
      return new Promise(function (resolve) {
        try {
          if (!projectKey || !changesBase) {
            resolve(null);
            return;
          }
          fetch(changesBase + "/" + projectKey + "/selectors", {
            method: "GET",
            credentials: "omit",
          })
            .then(function (res) {
              return res && res.ok ? res.json() : null;
            })
            .then(function (data) {
              if (data && Array.isArray(data.selectors)) {
                resolve({ version: data.version || "", selectors: data.selectors });
              } else {
                resolve(null);
              }
            })
            .catch(function () {
              resolve(null);
            });
        } catch (e) {
          resolve(null);
        }
      });
    },

    hashString: function (str) {
      let hash = 5381;
      const s = String(str || "");
      for (let i = 0; i < s.length; i++) {
        hash = ((hash << 5) + hash + s.charCodeAt(i)) | 0;
      }
      return Math.abs(hash);
    },
  };

  window.MVTUtils = UTILS;
})(window, document);
